import { render, staticRenderFns } from "./DataInterchangeModal.vue?vue&type=template&id=8005c24e&scoped=true"
import script from "./DataInterchangeModal.vue?vue&type=script&lang=ts"
export * from "./DataInterchangeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8005c24e",
  null
  
)

export default component.exports